import { MenuItem } from "@/types/domain";
import { FavouritesSubMenu } from "./FavouritesSubMenu";
import { PipelinesSubMenu } from "./PipelinesSubMenu";
import { MenuItemRow } from "./MenuItemRow";

type MiniItemFlyoutProps = {
  item: MenuItem;
}

export const MiniItemFlyout = ({ item }: MiniItemFlyoutProps) => {
  return (
    <div
      className="fixed z-50 shadow-xl rounded-r-lg overflow-hidden"
      style={{
        left: 42,
        top: "var(--layout-top-bar-height)",
        bottom: 0,
        minWidth: 200,
        backgroundColor: "var(--layout-side-nav-bg)",
        color: "var(--layout-side-nav-text)",
      }}
    >
      <div
        className="px-3 py-2 text-xs font-semibold uppercase border-b border-white/20"
        style={{ color: "var(--layout-side-nav-header)" }}
      >
        {item.label}
      </div>
      <ul className="py-1 space-y-0.5">
        {item.type === "favourites" && <FavouritesSubMenu />}
        {item.type === "pipelines" && <PipelinesSubMenu />}
        {item.type === "dropdown" &&
          item.children?.map((child) => (
            <MenuItemRow key={child.id} item={child} isMini={false} depth={0} openItemId={undefined} />
          ))}
      </ul>
    </div>
  );
};
